export default class FormStepsController {
    constructor() {
        this.btns = document.querySelectorAll('.js-step-btn');
        this.stepIndicators = document.querySelectorAll('.js-step-indicator');
        this.persons = document.querySelectorAll('.js-person');
        this.msgTypes = document.querySelectorAll('.js-msg-type');
        this.steps = document.querySelectorAll('.js-step');
        this.personInput = document.querySelector('#person');
        this.msgTypeInput = document.querySelector('#msgType');
        this.personDataLayerItems = ['savjet', 'korak-1'];
        this.msgTypeDataLayerItems = ['savjet', 'korak-2'];

        if (this.steps.length > 0) {
            this.init();
        }
    }

    init() {
        for (let btn of this.btns) {
            this.goToStep(btn);
        }

        for (let person of this.persons) {
            this.selectPerson(person);
        }

        this.activateSelectedPerson();

        for (let type of this.msgTypes) {
            this.selectMsgType(type);
        }
    }

    changeIndicator(index) {
        for (let i = 0; i < this.stepIndicators.length; i++) {
            if (i < parseInt(index)) {
                if (!this.stepIndicators[i].classList.contains('is-finished')) {
                    this.stepIndicators[i].classList.add('is-finished');
                    this.stepIndicators[i].classList.remove('is-active');
                }
            } else if (i === parseInt(index)) {
                if (!this.stepIndicators[i].classList.contains('is-active')) {
                    this.stepIndicators[i].classList.add('is-active');
                }
            }
        }
    }

    goToStep(btn) {
        btn.addEventListener('click', (ev) => {
            ev.preventDefault();

            this.moveToIndex(btn.dataset.index);

            let data = this.personDataLayerItems;

            if (parseInt(btn.dataset.index) === 2) {
                data = this.msgTypeDataLayerItems;
            }

            this.sendDataLayer(data[0], data[1], data[2]);
        });
    }

    selectPerson(person) {
        person.addEventListener('click', () => {
            let btn = document.querySelector('.js-step-btn[data-index="1"]');
            btn.classList.remove('is-inactive');

            for (let i = 0; i < this.persons.length; i++) {
                this.persons[i].classList.remove('is-active');
            }

            this.personInput.value = person.dataset.personIndex;

            person.classList.add('is-active');

            this.personDataLayerItems[2] = person.dataset.fullName;
        });
    }

    selectMsgType(type) {
        type.addEventListener('click', () => {
            let btn = document.querySelector('.js-step-btn[data-index="2"]');
            btn.classList.remove('is-inactive');

            for (let i = 0; i < this.msgTypes.length; i++) {
                this.msgTypes[i].classList.remove('is-active');
            }

            this.msgTypeInput.value = type.dataset.msgTypeIndex;

            let person = document.querySelector(`[data-person-index="${this.personInput.value}"]`);
            let label = `${type.dataset.msgType} - ${person.dataset.fullName}`;

            this.msgTypeDataLayerItems[2] = label;

            type.classList.add('is-active');
        });
    }

    activateSelectedPerson() {
        const selectedPerson = document.querySelector('.js-person.is-active');

        if (!selectedPerson) {
            return;
        }

        this.personInput.value = selectedPerson.dataset.personIndex;

        this.moveToIndex(1);
    }

    moveToIndex(index) {
        this.changeIndicator(index);

        for (let i = 0; i < this.steps.length; i++) {
            if (i !== parseInt(index)) {
                this.steps[i].classList.remove('is-active');
            } else {
                this.steps[i].classList.add('is-active');
            }
        }
    }

    sendDataLayer(category, action, label) {
        dataLayer.push({
            'event': '_d_GAEvent',
            'eventCategory': category,
            'eventAction': action,
            'eventLabel': label
        });
    }
}


